import React from "react";
import classes from './linkBlock.module.css';
import { Link } from 'react-router-dom';

const LinkBlock = (props) => {
    return (
        
        <div className={classes.linkBlock}>
            <Link to={props.block.linkto}>
                <div className={classes.linkBlock_info}>
                    <img src={props.logo} className={classes.linkLogo} />
                    <h3>{props.block.title}</h3>
                </div>
                <img src={props.block.linkImg} className={classes.linkImg}/>
                <div className={classes.linkBlock_bg}></div>
            </Link>
        </div>
    )
}

export default LinkBlock;